







import { defineComponent, ref, watch } from "@vue/composition-api";
import { debounce } from "lodash-es";
import useAuthUser from "@/hooks/useAuthUser";
import providers from "@/lib/api";
import BaseSwitch from "@/components/BaseSwitch";

export default defineComponent({
  name: "LastOnlineVisibilitySetting",
  components: { BaseSwitch },
  setup() {
    const { authUserStrict } = useAuthUser();
    const value = ref(false);

    const getData = async () => {
      const response = await providers.OnlineStatusProvider.searchUserSettings({ userId: authUserStrict.value.id });
      value.value = response.hideLastOnlineTime;
    };

    const updateData = debounce(async () => {
      await providers.OnlineStatusProvider.updateUserSettings({ data: { hideLastOnlineTime: value.value } });
    }, 300);

    getData().then(() => watch(value, updateData));

    return {
      value,
    };
  },
});
